import { isDatapointWithinSelection } from './is-datapoint-within-selection.js';
import type { ChartUnit } from '../../../../../core/types/chart-unit.js';
import { TimeseriesDatapoint } from '../../../../../core/types/timeseries.js';
import { safeGet } from '../../../../../core/utils/safe-get.js';
import type { WeakMapDatapoints } from '../../../../types/timeseries.js';
import { getDatapointTime } from '../../../../utils/timeseries.js';
import type { TimeseriesDataPointAllTypes } from '../../../displays/shared/types.js';

export const getSelectedDatapoints = (
  allDatapoints: TimeseriesDataPointAllTypes[],
  datapointsMap: WeakMapDatapoints,
  range: [Date, Date],
) => {
  const [from, to] = range;
  const selectedDatapoints = new Map<
    string | string[],
    (TimeseriesDatapoint & { unit: ChartUnit })[]
  >();

  for (const datapoint of allDatapoints) {
    const datapointDate = new Date(
      getDatapointTime(datapoint.start, datapoint.end),
    );
    if (isDatapointWithinSelection(datapointDate, from, to)) {
      const { start, end, center, unit, value, seriesName } = safeGet(
        datapointsMap,
        datapoint,
      );

      const datapointKey = seriesName;

      const dataPoint: TimeseriesDatapoint & { unit: ChartUnit } = {
        start,
        end,
        center,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        value: value!,
        unit,
      };

      selectedDatapoints.set(
        datapointKey,
        selectedDatapoints.has(datapointKey)
          ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            [...selectedDatapoints.get(datapointKey)!, dataPoint]
          : [dataPoint],
      );
    }
  }
  return selectedDatapoints;
};
